import { render, staticRenderFns } from "./BlockAdv.vue?vue&type=template&id=ce6077d0&scoped=true&lang=pug&"
import script from "./BlockAdv.vue?vue&type=script&lang=ts&"
export * from "./BlockAdv.vue?vue&type=script&lang=ts&"
import style0 from "./BlockAdv.vue?vue&type=style&index=0&id=ce6077d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6077d0",
  null
  
)

export default component.exports